"use client"

import { cn } from "@/lib/utils"
import { CalendarIcon, ListIcon } from "lucide-react"

export type ViewMode = "calendar" | "grid"

interface ViewToggleProps {
  view: ViewMode
  onViewChange: (view: ViewMode) => void
  className?: string
}

export function ViewToggle({ view, onViewChange, className }: ViewToggleProps) {
  return (
    <div className={cn("flex rounded-md overflow-hidden border", className)}>
      <button
        className={cn(
          "flex items-center justify-center p-2 w-10 h-8 transition-colors",
          view === "calendar" ? "bg-primary text-white" : "bg-white text-gray-700 hover:bg-gray-100",
        )}
        onClick={() => onViewChange("calendar")}
        aria-label="Calendar view"
      >
        <CalendarIcon className="h-4 w-4" />
      </button>
      <button
        className={cn(
          "flex items-center justify-center p-2 w-10 h-8 transition-colors",
          view === "grid" ? "bg-primary text-white" : "bg-white text-gray-700 hover:bg-gray-100",
        )}
        onClick={() => onViewChange("grid")}
        aria-label="List view"
      >
        <ListIcon className="h-4 w-4" />
      </button>
    </div>
  )
}

